<script>
  import { slide } from 'svelte/transition'
  import LegendCard from './LegendCard.svelte'
  import LegendSwitch from './LegendSwitch.svelte'
  import FloodCategories from './FloodCategories.svelte'

  export let assetURL
  export let series
  export let streamflows
  export let stageflows
  export let shortLegend
  export let chart
  export let floodCatUnits
  export let floodcategories
  export let gauge = null // added for Chrome warning

  let srCopy = [...streamflows],
    mediumRanges = [],
    longRanges = []
  streamflows = []

  // Seperate forecastEnsemble objects from streamflows
  srCopy.forEach((v, i) => (/medium_range_ensemble_/.test(v.userOptions.id) ? mediumRanges.push(v) : v))
  srCopy.forEach((v, i) => (/long_range_ensemble_/.test(v.userOptions.id) ? longRanges.push(v) : v))
  streamflows = srCopy.filter((v, i) => !longRanges.includes(v) && !mediumRanges.includes(v))

  // Sort streamflows, MR and LR
  streamflows.sort((a, b) => {
    return a.userOptions.id > b.userOptions.id ? 1 : -1
  })
  mediumRanges.sort((a, b) => {
    return a.userOptions.id > b.userOptions.id ? 1 : -1
  })
  longRanges.sort((a, b) => {
    return a.userOptions.id > b.userOptions.id ? 1 : -1
  })

  // Set visible switches
  mediumRanges.filter((i) => {
    i.setVisible(false)
  })
  longRanges.filter((i) => i.setVisible(false))

  // Handle the open-close of the forecast ensemble accordion buttons
  let isOpenLR = false
  let isOpenMR = false
  const toggleLR = () => (isOpenLR = !isOpenLR)
  const toggleMR = () => (isOpenMR = !isOpenMR)
</script>

<div class="uk-grid-collapse uk-grid-match cards pad" uk-grid>
  {#if stageflows.length > 0}
    <div
      class="uk-width-1-{series.ratingsCurve == null
        ? 1
        : stageflows.length === 0 || (streamflows.length === 0 && mediumRanges.length === 0 && longRanges.length === 0)
        ? 2
        : 3} padright"
    >
      <LegendCard title="Traces and Thresholds" helpText="Click to turn on/off display">
        {#each stageflows as stage}
          <LegendSwitch {series} type={stage} {chart} {shortLegend} />
        {/each}
      </LegendCard>
    </div>
  {/if}

  <div
    class="uk-width-1-{series.ratingsCurve == null
      ? 1
      : stageflows.length === 0 || (streamflows.length === 0 && mediumRanges.length === 0 && longRanges.length === 0)
      ? 2
      : 3} padright"
  >
    {#if floodCatUnits}
      <FloodCategories {assetURL} flood={floodcategories} {floodCatUnits} />
    {/if}
  </div>

  {#if streamflows.length > 0 || mediumRanges.length > 0 || longRanges.length > 0}
    <div class="uk-width-1-{series.ratingsCurve == null ? 1 : stageflows.length == 0 ? 2 : 3}">
      <LegendCard title="National Water Model">
        {#each streamflows as nwm}
          <LegendSwitch {series} type={nwm} {chart} {shortLegend} />
        {/each}

        {#if mediumRanges.length > 0}
          <button on:click={toggleMR} aria-expanded={isOpenMR}>
            <svg
              style="tran"
              width="20"
              height="20"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"><path d="M9 5l7 7-7 7" /></svg
            >Medium Range Ensembles
          </button>
          {#if isOpenMR}
            <ul transition:slide={{ duration: 300 }}>
              {#each mediumRanges as mediumRange}
                <LegendSwitch {series} type={mediumRange} {chart} {shortLegend} />
              {/each}
            </ul>
          {/if}
        {/if}

        {#if longRanges.length > 0}
          <button on:click={toggleLR} aria-expanded={isOpenLR}>
            <svg
              style="tran"
              width="20"
              height="20"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"><path d="M9 5l7 7-7 7" /></svg
            >Long Range Ensembles
          </button>
          {#if isOpenLR}
            <ul transition:slide={{ duration: 300 }}>
              {#each longRanges as longRange}
                <LegendSwitch {series} type={longRange} {chart} {shortLegend} />
              {/each}
            </ul>
          {/if}
        {/if}
      </LegendCard>
    </div>
  {/if}
</div>

<style>
  .pad {
    margin: 2px;
  }
  .padright {
    padding-right: 2px;
  }

  /* accordion css */
  button {
    border: none;
    background: none;
    display: block;
    color: inherit;
    font-size: 1em;
    font-weight: 700;
    cursor: pointer;
    margin-left: -5;
    padding-bottom: 0.5em;
    padding-top: 0.5em;
    margin-left: -20px;
  }

  svg {
    transition: transform 0.2s ease-in;
  }

  [aria-expanded='true'] svg {
    transform: rotate(0.25turn);
  }
</style>
